<form
  (ngSubmit)="submitForm()"
  [formGroup]="formGroup"
  [nzLayout]="'vertical'"
  nz-form>
  <nz-form-item>
    <nz-form-control
      i18n-nzErrorTip="@@search-form-input-error-tip"
      nzErrorTip="Please, enter correct username or Instagram link">
      <nz-input-group
        [nzPrefixIcon]="'instagram'"
        [nzSize]="'large'"
        [nzSuffix]="suffix">
        <input
          (input)="onSearchInput($event)"
          [formControlName]="'username'"
          [type]="'text'"
          i18n-placeholder="@@search-form-input-placeholder"
          nz-input
          placeholder="Username or Instagram link" />
      </nz-input-group>
      <ng-template #suffix>
        <button
          [disabled]="formGroup.invalid"
          [nzLoading]="loading()"
          [nzShape]="'circle'"
          [nzSize]="'large'"
          [nzType]="'primary'"
          i18n-title="@@search-form-button-title"
          nz-button
          title="Search profile">
          <nz-icon [nzTheme]="'outline'" [nzType]="'search'" />
        </button>
      </ng-template>
    </nz-form-control>
  </nz-form-item>
</form>
